import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { MediaImage_Fragment } from "./mediaimage";
// import { ProductVariant_Fragment } from "./product-variant";

export const ProductOption_Fragment = graphqlShopifyStorefront(
  `
  fragment ProductOption on ProductOption {
    id
    name
    optionValues {
        firstSelectableVariant {
            ...ProductVariant
        }
        id
        name
        swatch {
            ... on ProductOptionValueSwatch {
                color
                image {
                    ...MediaImage
                }
            }
        }
    }
  }
`,
  //   [MediaImage_Fragment, ProductVariant_Fragment],
);
